// extracted by mini-css-extract-plugin
export default {"tabs":"DeviceDistribution_tabs__DdYBe"};